import { observer } from "mobx-react-lite";
import { Form, Input, Modal } from "antd";

import React, { useEffect, useState } from "react";
import RoleStore, { RoleInfo } from "../../../../stores/Admin/RoleStore";
const { TextArea } = Input;
export interface RoleAddDialogProps {
  visible: boolean;
  roleInfo: {
    id?: number;
    name: string;
    //  code?: string;
    des?: string;
  };
  close: () => void;
}

const RoleEditDialog: React.FC<RoleAddDialogProps> = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(props.roleInfo);
  }, [props.visible]);

  const submit = () => {
    form
      .validateFields()
      .then((res) => {
        const values = { ...form.getFieldsValue(), id: props.roleInfo.id };
        RoleStore.editRole(values);
        console.log(values);
        props.close();
      })
      .catch((err) => {});
  };
  return (
    <Modal
      forceRender
      title="编辑分组"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <Form form={form}>
        <Form.Item
          label="分组名称"
          name="name"
          rules={[{ required: true, message: "名称不能为空" }]}
        >
          <Input placeholder="请输入分组名称" />
        </Form.Item>
        {/* <Form.Item label="角色编码" name="code">
          <Input placeholder="请输入角色编码" />
        </Form.Item> */}
        <Form.Item label="分组描述" name="des">
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default observer(RoleEditDialog);
